const APIService = require('../../../app/services/ApiService');
const NotificationService = require('../../../app/services/NotificationService');
const ValidationService = require('../../../app/services/ValidationService');

import TranslationService from '../../../app/services/TranslationService';
import Vue from 'vue';

export default Vue.component('create-order-return', {

    props: {
        template:
            {
                type: String,
                default: '#vue-create-order-return',
            },
        maxReturns: {
            type: Number,
            required: true,
        },
        returns: {
            type: Array,
            required: true,
        },
        orderId: {
            type: Number,
            required: true,
        },
        orderAccessKey: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            isLoading: false,
            createdReturns: [],
            returnToDisplay: null,
            qrCodeLoaded: false
        };
    },

    /**
     * Initialise the account settings modal
     */
    mounted() {
    },

    computed: {
        hasReturnsLeft() {
            return this.allReturns.length < this.maxReturns;
        },
        allReturns() {
            return [...this.returns, ...this.createdReturns];
        },
        returnHint() {
            return TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationOrderReturnHint',
                { returnInformationUrl: TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationOrderReturnHintUrl') });
        },
    },

    methods: {
        showQrCode(orderReturn) {
            if(!this.returnToDisplay || this.returnToDisplay.id !== orderReturn.id) {
                this.qrCodeLoaded = false;
            }
            this.returnToDisplay = orderReturn;
            Vue.nextTick(() =>
            {
                $(this.$refs.orderReturnModal).modal("show");
                document.dispatchEvent(new CustomEvent('onReturnQrCodeShowed', {
                    detail: {},
                }));
            });
        },
        createReturn() {
            this.isLoading = true;
            APIService.post('/rest/modeherz/shop/orders/returns', {
                          orderId: this.orderId,
                          orderAccessKey: this.orderAccessKey,
                      }, { supressNotifications: true })
                      .done(response => {
                          this.createdReturns.push(response);
                          NotificationService.success(
                              TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationOrderReturnRequestSuccess'),
                          ).closeAfter(3000);
                          document.dispatchEvent(new CustomEvent('onReturnLabelCreated', {
                              detail: {},
                          }));

                      }).fail((response, status) => {
                          const message = TranslationService.translate('modeherz::OrderConfirmationPageClient.orderConfirmationOrderReturnRequestError');
                          NotificationService.error(message);
                      })
                      .always(() => {
                          this.isLoading = false;
                      });
        },

    },

});
